export const COLORS = {
	PRIMARY: "#060606",
	BACKGROUND: "#F8F8F8",
	THEME_COLOR: "#3d619b",
	SUCESS: "#28a745",
	INFO: "#17a2b8",
	WARNING: "#ffc107",
	DANGER: "#dc3545",
	DARK: "#343a40",
	LIGHT: "#f8f9fa",
};
